module.exports = __webpack_public_path__ + "static/media/playground.b5cb9218.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/playground.mp4
// module id = 351
// module chunks = 0